import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DictionaryEntry } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { AddCatalogNode } from '../../catalog.model';

@Component({
  selector: 'app-add-catalog-node-dialog',
  templateUrl: './add-catalog-node-dialog.component.html',
  styleUrls: ['./add-catalog-node-dialog.component.scss']
})
export class AddCatalogNodeDialogComponent implements OnInit {

  name = new DictionaryEntry();

  catalogId: number;
  parentNodeId: number;

  constructor(
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<AddCatalogNodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpService
  ) {

    this.catalogId = data.catalogId;
    this.parentNodeId = data.parentNodeId;

    console.log('dialog initialized with', this.catalogId, this.parentNodeId);
  }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.http.postWithContext<number>(environment.erpCatalogEndpoint + '/addCatalogNode',
      new AddCatalogNode({ catalogId: this.catalogId, parentNodeId: this.parentNodeId, name: this.name }))
      .subscribe(response => {

        console.log('response is', response);

        this.dialogRef.close();

      }, error => {
        console.log('error is', error);
      });
  }

  confirmDisabled(): boolean {
    return this.name == null || this.name.values == null || this.name.values.length === 0 || !this.name.checkValueExistsForLanguage('de');
  }

  public onNameChanged(dictionary: DictionaryEntry) {
    this.name = new DictionaryEntry(dictionary);
  }

}
